import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Currency from 'components/consumer/Currency';
import IconCheck from 'components/icons/iconCheck';
import IconFourSquare from 'components/icons/iconFourSquare';
import JBImage from 'components/essentials/JBImage';
import Link from 'components/consumer/Link';
import isExternalLink from 'commons/isExternalLink';
import getSofaBuilderLink from 'commons/getSofaBuilderLink';
const PDPAvailableInSizesListItem = t0 => {
  const $ = _c(47);
  const {
    byoCollectionName,
    dimensions,
    id,
    image,
    isActive,
    isBYO: t1,
    name,
    price,
    urlKey,
    productsData: t2
  } = t0;
  const isBYO = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const productsData = t3;
  let t4;
  if ($[2] !== urlKey) {
    t4 = urlKey?.includes("?") ? {
      pathname: urlKey.split("?")[0],
      search: urlKey.split("?")[1]
    } : {
      pathname: urlKey
    };
    $[2] = urlKey;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isBYO ? undefined : id;
  let t6;
  if ($[4] !== productsData || $[5] !== t5) {
    t6 = {
      resetState: false,
      scrollToTop: false,
      productId: t5,
      source: "PDPAvailableInSizesRowUI",
      initialIsExpanded: true,
      productsData
    };
    $[4] = productsData;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t6) {
    t7 = {
      ...t4,
      state: t6
    };
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const linkTo = t7;
  let t8;
  if ($[10] !== byoCollectionName || $[11] !== isBYO || $[12] !== urlKey) {
    t8 = event => {
      if (isBYO) {
        event.preventDefault();
        const sofaBuilderLink = getSofaBuilderLink(byoCollectionName, urlKey);
        if (isExternalLink(sofaBuilderLink)) {
          window.open(sofaBuilderLink);
        } else {
          window.location.href = sofaBuilderLink;
        }
      }
    };
    $[10] = byoCollectionName;
    $[11] = isBYO;
    $[12] = urlKey;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = !isActive;
  let t10;
  if ($[14] !== isActive || $[15] !== isBYO || $[16] !== t9) {
    t10 = cx("relative flex w-full justify-between border h-20 p-4 mt-3 text-gray rounded-sm hover:border-gray-light2 hover:transition-border hover:duration-300", {
      "border-gray-dark": isActive,
      "border-gray-light6": t9,
      "normal-case": isBYO
    });
    $[14] = isActive;
    $[15] = isBYO;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== isActive) {
    t11 = isActive && <div className="flex justify-center items-center bg-gray-dark h-4 w-4 absolute rounded-sm top-0 right-0 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg>path]:fill-white [&>svg>path]:stroke-white"><IconCheck /></div>;
    $[18] = isActive;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== image || $[21] !== isBYO) {
    t12 = <div className="flex justify-center items-center [&>svg]:w-14 h-12 w-14 mr-2">{!isBYO && image ? <JBImage src={image} width={56} /> : <IconFourSquare />}</div>;
    $[20] = image;
    $[21] = isBYO;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== name) {
    t13 = <div className="text-sm font-bold">{name}</div>;
    $[23] = name;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== dimensions) {
    t14 = <div className="text-xs text-gray-light2 lowercase">{dimensions}</div>;
    $[25] = dimensions;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t13 || $[28] !== t14) {
    t15 = <div className="flex flex-col ml-1">{t13}{t14}</div>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t12 || $[31] !== t15) {
    t16 = <div className="flex">{t12}{t15}</div>;
    $[30] = t12;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== isBYO || $[34] !== price) {
    t17 = !isBYO ? <div className="font-bold text-sm">{" "}<Currency>{price}</Currency></div> : null;
    $[33] = isBYO;
    $[34] = price;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17) {
    t18 = <div className="flex">{t17}</div>;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t16 || $[41] !== t18) {
    t19 = <div className={t10}>{t11}{t16}{t18}</div>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t16;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== linkTo || $[44] !== t19 || $[45] !== t8) {
    t20 = <Link to={linkTo} className="text-gray !no-underline !hover:no-underline" onClick={t8}>{t19}</Link>;
    $[43] = linkTo;
    $[44] = t19;
    $[45] = t8;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  return t20;
};
PDPAvailableInSizesListItem.propTypes = {
  byoCollectionName: PropTypes.string,
  dimensions: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  image: PropTypes.string,
  isActive: PropTypes.bool,
  isBYO: PropTypes.bool,
  name: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  urlKey: PropTypes.string,
  productsData: PropTypes.arrayOf(PropTypes.object)
};
export default PDPAvailableInSizesListItem;